// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
/**
 * Returns a `Date` that is corrected for clock skew.
 *
 * @param systemClockOffset The offset of the system clock in milliseconds.
 *
 * @returns `Date` representing the current time adjusted by the system clock offset.
 *
 * @internal
 */
export var getSkewCorrectedDate = function (systemClockOffset) {
    return new Date(Date.now() + systemClockOffset);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-amplify/cache/node_modules/@aws-amplify/core/lib-esm/clients/middleware/signing/utils/getSkewCorrectedDate.js
// module id = SxTb
// module chunks = 0